// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';

// // Здесь вы можете добавить поддержку для разных языков
// i18n
//   .use(initReactI18next) // passes i18n down to react-i18next
//   .init({
//     resources: {
//       en: {
//         // translation: require('./locales/en/translation.json'),
//         lang: {
//           title: 'Lang',
//         },
//       },
//       es: {
//         translation: {
//           // Здесь добавьте ключи и значения для испанского языка
//         },
//       },
//       ua: {
//         translation: {
//           // Здесь добавьте ключи и значения для украинского языка
//           lang: {
//             title: 'Мова',
//           },
//         },
//       },
//       ru: {
//         translation: {
//           // Здесь добавьте ключи и значения для русского языка
//         },
//       },
//       // ru: {
//       //   translation: {
//       //     // Здесь добавьте ключи и значения для русского языка
//       //   },
//       // },
//       // Добавьте другие языки по мере необходимости
//     },
//     lng: 'en', // язык по умолчанию
//     fallbackLng: 'en', // язык, используемый по умолчанию, если выбранный не найден
//     interpolation: {
//       escapeValue: false, // необходимо для реакта
//     },
//   });

// export default i18n;

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: require('./locales/en/translation.json'),
        // translation: {
        // here we will place our translations...
        // lang: {
        //   title: 'Lang',
        // },
        // },
      },
      ua: {
        translation: require('./locales/ua/translation.json'),
        // translation: {
        //   // here we will place our translations...
        //   lang: {
        //     title: 'Мова',
        //   },
        // },
      },
      ru: {
        translation: require('./locales/ru/translation.json'),
      },
      es: {
        translation: require('./locales/es/translation.json'),
      },
    },
  });

export default i18n;
